import React from "react";
import { useTheme } from "@mui/material/styles";

const EditIcon = () => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M13.7281 3.59997L5.51811 12.29C5.20811 12.62 4.90811 13.27 4.84811 13.72L4.47811 16.96C4.34811 18.13 5.18811 18.93 6.34811 18.73L9.56811 18.18C10.0181 18.1 10.6481 17.77 10.9581 17.43L19.1681 8.73997C20.5881 7.23997 21.2281 5.52997 19.0181 3.43997C16.8181 1.36997 15.1481 2.09997 13.7281 3.59997Z"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3574 5.05005C12.7874 7.81005 15.0274 9.92005 17.8074 10.2"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.46777 22H21.4678"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
